import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { createBrowserRouter } from 'react-router'
import '@k1p4/ui/fonts.css'
import '@k1p4/ui/theme.css'
import { AppRoot, createQueryClient } from './AppRoot'
import { routes } from './router'
import { i18n } from './i18n'
import './styles/global.css'

const queryClient = createQueryClient()

const router = createBrowserRouter(routes)

const container = document.getElementById('root')
if (container === null) {
  throw new Error('Brak elementu #root — sprawdź index.html')
}

createRoot(container).render(
  <StrictMode>
    <AppRoot i18n={i18n} queryClient={queryClient} router={router} />
  </StrictMode>,
)
